// ATENÇÃO: Sempre que um novo campo for adicionado
// set a propriedade visible para false
export default [
  {
    id: 'name',
    text: 'Nome',
    title: 'Nome do grupo de devices',
    visible: true
  },
  {
    id: 'departmentName',
    text: 'Departmento',
    title: 'Nome do departamento do grupo',
    visible: true
  },
  {
    id: 'free',
    text: 'Livres',
    title: 'Quantide de canais disponiveis agora',
    visible: true
  },
  {
    id: 'busy',
    text: 'Ocupados',
    title: 'Quantidade de canais ocupados agora',
    visible: true
  },
  {
    id: 'incoming',
    text: 'Entrada',
    title: 'Quantidade de canais ocupados com chamadas de entrada',
    visible: true
  },
  {
    id: 'outgoing',
    text: 'Saintes',
    title: 'Quantidade de canais ocupados com chamadas de saída',
    visible: true
  },
  {
    id: 'maxfree',
    text: 'Max. Livres',
    title: 'Maximo de canais que ficaram livres no periodo',
    visible: true
  },
  {
    id: 'timemaxfree',
    text: 'H:Max. Livres',
    title: 'Momento em que o maximo de canais que ficaram livres no periodo',
    visible: true
  },
  {
    id: 'maxbusy',
    text: 'Max. Ocupados',
    title: 'Maximo de canais que ficaram ocupados no periodo',
    visible: true
  },
  {
    id: 'timemaxbusy',
    text: 'H:Max. Ocupados',
    title: 'Momento em que o maximo de canais que ficaram ocupados no periodo',
    visible: true
  },
  {
    id: 'maxincoming',
    text: 'Max. Entrante',
    title:
      'Maximo de canais que ficaram ocupados com chamada de entrada no periodo',
    visible: true
  },
  {
    id: 'timemaxincoming',
    text: 'H:Max. Entrante',
    title:
      'Momento em que  ficaram ocupados o maior número de canais com chamada de entrada no periodo',
    visible: true
  },
  {
    id: 'maxoutgoing',
    text: 'Max. Saintes',
    title:
      'Maximo de canais que ficaram ocupados com chamada de saida no periodo',
    visible: true
  },
  {
    id: 'timemaxoutgoing',
    text: 'H:Max. Saintes',
    title:
      'Momento em que  ficaram ocupados o maior numero de canais com chamada de saida no periodo',
    visible: true
  },
  {
    id: 'minfree',
    text: 'Min. Livres',
    title: 'Minimo de canais que ficaram livres no periodo',
    visible: true
  },
  {
    id: 'timeminfree',
    text: 'H:Min. Livres',
    title: 'Momento em que o minimo de canais ficaram livres no periodo',
    visible: true
  },
  {
    id: 'minbusy',
    text: 'Min. Ocupados',
    title: 'Minimo de canais que ficaram ocupados no periodo',
    visible: true
  },
  {
    id: 'timeminbusy',
    text: 'H:Min. Ocupados',
    title: 'Momento em que o minimo de canais ficaram ocupados no periodo',
    visible: true
  },
  {
    id: 'minincoming',
    text: 'Min. Entrante',
    title:
      'Minimo de canais que ficaram ocupados com chamada de entrada no periodo',
    visible: true
  },
  {
    id: 'timeminincoming',
    text: 'H:Min. Entrante',
    title:
      'Momento em que ficaram ocupados o minimo de canais chamada de entrada no periodo',
    visible: true
  },
  {
    id: 'minoutgoing',
    text: 'Min. Saintes',
    title:
      'Minimo de canais que ficaram ocupados com chamada de saida no periodo',
    visible: true
  },
  {
    id: 'timeminoutgoing',
    text: 'H:Min. Saintes',
    title:
      'Momento em que ficaram ocupados o minimo de canais chamada de saida no periodo',
    visible: true
  }
];
